interface DebugPanelProps {
  userPermission: string;
}

export default function DebugPanel({ userPermission }: DebugPanelProps) {
  return (
    <div
      style={{
        background: 'var(--surface-card)',
        border: '1px solid var(--border-hairline)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-rest)',
        padding: '10px 14px',
        marginBottom: 'var(--space-4)',
      }}
    >
      <p className="t-num" style={{ margin: 0, fontSize: 'var(--text-xs)', color: 'var(--text-faint)' }}>
        Current User Permission Level:{' '}
        <span
          style={{
            color: 'var(--accent-text)',
            fontWeight: 'var(--weight-semibold)' as React.CSSProperties['fontWeight'],
          }}
        >
          {userPermission}
        </span>
      </p>
    </div>
  );
}
